import React,{useState,useContext} from 'react'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
//import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { Box, LinearProgress, IconButton,Tooltip, //Card  ,CardContent ,
    Breadcrumbs, Typography,Button, FormControl,
InputLabel, Select, TextField,  } from '@material-ui/core'
//import moment from 'moment'; 
import axios from 'axios';
import qs from 'qs';
//import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SearchIcon from '@material-ui/icons/Search';
import {llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import TablaUsuario from './TablaUsuario';
import TablaPerfil from './TablaPerfil';
import NuevoUsuario from "./EditUsuario";
import {findNumber} from "../funciones/FindNumber";
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },    
    title: {
      fontSize: 28,
    },
    title2: {
        fontSize: 18,
      },
    subTitle2: {
        fontSize: 12,
      },
    pos: {
      marginBottom: 12,
    },
    addButton: {
        marginRight: theme.spacing(2),       
      },
    altura2: {
        minHeight: 70,    
        marginTop:0,
        paddingTop:0,    
    },
    altura3: {
        minHeight: 100,
        marginTop:0,
        paddingTop:0,    
    },
    altura1: {
        height: 90,        
    },
    textoSelect: {
        '&:hover': {
          color:'#9ccdfa',
        },
        fontSize:1.25+'rem'
      },
  }));

  const listEstatus=[
    {Id:-1, descr:"Sin Filtro"},
    {Id:0, descr:"Estatus Inactivo"},
    {Id:1, descr:"Estatus Activo"}
  ]

const Usuarios = () => {
    let nvlSNPermiso ='5'  
    let history = useHistory();
    const classes = useStyles();    
    const source = axios.CancelToken.source();
    const idusu= localStorage.getItem('UsuId');
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const {guardarGenerales}= useContext(GeneralesContext);                   
    const [buscar, setBuscar] = useState(true);    
    const [modalNvo, setModalNvo] = useState(false);                    
    const [listUsuarios, setListUsuarios] = useState([])    
    const [listTipo, setListTipo] = useState([]) 
    const [usuSelect, setUsuSelect] = useState([])    
    const [opcion,setOpcion]=useState(1)
    const [espera,setEspera]=useState(false)     
    const [filtro, setFiltro] = useState({estatus:-1, tipo:0, puesto:"", nombre:""});    
    const {estatus, tipo, puesto, nombre}= filtro

    React.useEffect(()=>{               
   
		const veriSesion =  () => {            
            const usu= localStorage.getItem('UsuarioNom');
            const nvl= localStorage.getItem('Tipo');   
            if(usu === null)
            {                                
                guardarUsuario([])						
                guardarGenerales([])     
                localStorage.clear();           
                history.push("/")	
            }
            else
            {   if (usuario.length === 0) 
                {   guardarUsuario({Nombre:usu,nivel:nvl});                                      
                }
                if (listTipo.length === 0 ) {
                    getListaPerfil()         
                }
                guardarGenerales({Titulo:'Catalogo Usuarios'})  
                            
                llenarListUsu()        
            }
        }
	    veriSesion();	

        return ()=> {
            source.cancel();
        } 

    },[buscar]);
                     
    const llenarListUsu = () => {      
        const data = qs.stringify({
            usuario:idusu,
            status:estatus,
            tipo:tipo,
            puesto:puesto,
            nombre:nombre,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/usuario/v2/list";
        function respuesta(aux) {
            if (aux[0].Id !== -1) 
            {                          
                setListUsuarios(aux);                             
            }
        }            
        llamadaApiToken(data, url, respuesta,ErrorGeneral,setEspera,history,source)
    }; 

    const getListaPerfil = () => {
        const data = qs.stringify({
            usuario: idusu, idDispositivo: 'WRF8754SD4SD'
        });
        const url = "/usuario-perfil-list";

        function respuesta(aux) {
            if (aux[0].Id !== -1) {
                setListTipo(aux)
            }
        }

        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source)
    };

    const actualizar=()=>{
        setBuscar(!buscar)
    }
    const selectOpcion =(e,auxValor)=>{
        e.preventDefault();
        //console.log(auxValor);
        setOpcion(auxValor)
    }

    const onChange = e => {
        setFiltro({
        ...filtro,
        [e.target.name]: e.target.value
        })
    };

    const menuOpcion=(  
        <Breadcrumbs separator="-"   aria-label="breadcrumb"   >        
            <Typography variant="h5" className={classes.textoSelect} 
                color={opcion === 1 ? "Primary":'textPrimary'} 
                onClick={e=>selectOpcion(e,1)}
            >
                Usuario
            </Typography>
          {/*   <Typography variant="h5" className={classes.textoSelect} 
                color={opcion === 2 ? "Primary":'textPrimary'} 
                onClick={e=>selectOpcion(e,2)}
            >
                Perfil
            </Typography>       */}
        </Breadcrumbs> 
    )
    function agregarUsuario() {
        setModalNvo(true)
    }

    const principal=()=>{        
        return(
        <Box display="flex" flexDirection="column" >                                        
            <Box display="flex" pt={1} pb={1} justifyContent='center' >
                {menuOpcion}
            </Box>
            { !espera   ?     
                (opcion===1 ?
                    <Box>
                        <Box display={"flex"} flexDirection={"row"} mb={1}>
                          
                            <Box display="flex" id="caja2"  flexDirection="row" mb={1} >                                                
                                <Tooltip title="Buscar Usuarios" >                          
                                    <IconButton color="inherit"  aria-label="add circle" 
                                        component="span" onClick={actualizar} size='small'
                                    >
                                    <SearchIcon color="primary" style={{ fontSize: 30 }}  size='small' />
                                    </IconButton>            
                                </Tooltip>                                  
                            </Box>                              
                            {listTipo.length !== 0 ? 
                                <FormControl size="small" style={{width:"12rem" , marginLeft:"1rem"}}>
                                <InputLabel htmlFor="age-native-simple" size="small">Tipo</InputLabel>
                                <Select   size="small" native
                                    value={tipo} onChange={onChange} 
                                    inputProps={{ name: 'tipo', id: 'TipoSecl',}}
                                >
                                    <option aria-label="None" value=""/>
                                    {listTipo.map((row) => (
                                    <option value={row.Id}>{row.Nom}</option>
                                    ))}
                                </Select>
                                </FormControl>
                            : null}
                            <FormControl size="small" style={{width:"9rem" , marginLeft:"1rem"}}>
                                <InputLabel htmlFor="age-native-simple" size="small">Estatus</InputLabel>
                                <Select   size="small" native
                                    value={estatus} onChange={onChange} 
                                    inputProps={{ name: 'estatus', id: 'estatusSecl',}}
                                >
                                    <option aria-label="None" value=""/>
                                    {listEstatus.map((row) => (
                                    <option value={row.Id}>{row.descr}</option>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField id="outlined-basicnombre" name="nombre"    
                                style={{ width: 10+"rem", marginLeft:".5rem" }}
                                label="Nombre" variant="outlined" size="small"
                                value={nombre} onChange={onChange}        
                            />    
                            <TextField id="outlined-basicpuesto" name="puesto"    
                                style={{ width: 10+"rem", marginLeft:".5rem" }}
                                label="Puesto" variant="outlined" size="small"
                                value={puesto} onChange={onChange}        
                            />                  
                            {findNumber('|16|') ?
                            <Box>
                                <Button onClick={agregarUsuario} variant="outlined" 
                                    size="small" color='primary' style={{marginLeft:".5rem", marginTop:".5rem"}}>
                                    Nuevo Usuario
                                </Button>
                            </Box> :null}
                        </Box>
                        <TablaUsuario  datos={listUsuarios} actualizar={actualizar} listTipo={listTipo}
                            usuario={usuario} />
                    </Box>
                    :null)
            : <Box> <LinearProgress /> </Box> }
            {opcion===2 ?
                <TablaPerfil  usuario={usuario} setUsuSelect={setUsuSelect} 
                    usuSelect={usuSelect} 
                />
            :null}                                 
        </Box>      
        )
    }
    const modalNuevo = modalNvo ? 
        (usuario?.nivel != undefined && usuario.nivel !== nvlSNPermiso ?
            <NuevoUsuario modalAbierto={modalNvo} setModalAbierto={setModalNvo} actualizar={actualizar}
                titulo={'Agregar Nuevo Usuario '}  user={usuario} isUpdate={false} listTipo={listTipo} /> 
            : null) 
        : null;

    return (
    <div>
        {principal()}
        {modalNuevo}
    </div>
    )
}

export default Usuarios
